import { render, staticRenderFns } from "./SectionRecommend.vue?vue&type=template&id=a9f673d6&scoped=true&lang=pug&"
import script from "./SectionRecommend.vue?vue&type=script&lang=js&"
export * from "./SectionRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SectionRecommend.vue?vue&type=style&index=0&id=a9f673d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f673d6",
  null
  
)

export default component.exports